import { defineComponent as _defineComponent } from 'vue';
import { BAlert, BButton, BForm, BFormGroup, BFormInput, BFormInvalidFeedback, BFormRadio, BModal, BSpinner, } from "bootstrap-vue";
import { storeToRefs } from "pinia";
import { computed, ref, watch } from "vue";
import { userOwnsHistory } from "@/api";
import { useHistoryStore } from "@/stores/historyStore";
import { useUserStore } from "@/stores/userStore";
import localize from "@/utils/localization";
export default /*#__PURE__*/ _defineComponent({
    __name: 'CopyModal',
    props: {
        history: null,
        showModal: { type: Boolean, default: false }
    },
    emits: ["update:show-modal"],
    setup(__props, { emit }) {
        const props = __props;
        const userStore = useUserStore();
        const historyStore = useHistoryStore();
        const { currentUser, isAnonymous } = storeToRefs(userStore);
        const name = ref("");
        const copyAll = ref(false);
        const loading = ref(false);
        const localShowModal = ref(props.showModal);
        const title = computed(() => {
            return `Copying History: ${props.history.name}`;
        });
        const saveTitle = computed(() => {
            return loading.value ? "Saving..." : "Copy History";
        });
        const saveVariant = computed(() => {
            return loading.value ? "info" : formValid.value ? "primary" : "secondary";
        });
        const isOwner = computed(() => {
            return userOwnsHistory(currentUser.value, props.history);
        });
        const newNameValid = computed(() => {
            if (isOwner.value && name.value == props.history.name) {
                return false;
            }
            return name.value.length > 0;
        });
        const formValid = computed(() => {
            return newNameValid.value;
        });
        watch(() => props.showModal, (newVal) => {
            localShowModal.value = newVal;
        });
        watch(() => localShowModal.value, (newVal) => {
            emit("update:show-modal", newVal);
        });
        watch(() => props.history, (newHistory) => {
            name.value = `Copy of '${newHistory.name}'`;
        }, {
            immediate: true,
        });
        async function copy(close) {
            loading.value = true;
            await historyStore.copyHistory(props.history, name.value, copyAll.value);
            loading.value = false;
            close();
        }
        return { __sfc: true, props, emit, userStore, historyStore, currentUser, isAnonymous, name, copyAll, loading, localShowModal, title, saveTitle, saveVariant, isOwner, newNameValid, formValid, copy, BAlert, BButton, BForm, BFormGroup, BFormInput, BFormInvalidFeedback, BFormRadio, BModal, BSpinner, localize };
    }
});
